import type { FC } from 'react';
import type { AggregatedScoreBreakdown } from '../../../apiHooks/useScoreBreakdownByUserQuery';
import styled from 'styled-components';
import { Icon, IconType } from '../../Props/Icon/Icon';
import { formatNumberWithCommas } from '../../../lib/numbers/formatNumberWithComma';
import { NamedContentEntryText } from '../../ContentEntryText/NamedContentEntryText';

type ScoreBreakdownTooltipProps = {
  item: AggregatedScoreBreakdown;
};

export const ScoreBreakdownTooltip: FC<ScoreBreakdownTooltipProps> = ({ item }: ScoreBreakdownTooltipProps) => {
  return (
    <TooltipContainer>
      <NamedContentEntryText refKey="scoreBreakdownTooltips" container="span" subKey="behaviorTotal" />
      <ScoreLabel>
        <span>{formatNumberWithCommas(item.globalScore)}</span>
        <Icon icon={IconType.COIN} width={20} height={20} />
      </ScoreLabel>
    </TooltipContainer>
  );
};

const TooltipContainer = styled.div`
  color: ${({ theme }) => theme.colors.heading};
  padding: 8px;
  width: max-content;
  min-width: 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const ScoreLabel = styled.label`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;
